import styled from '@emotion/styled';

export default styled('div')`
  margin-right: 10px;
`;
